import Map, { setAMapVersion, setAMapKey } from './components/Map';
import Marker, { IconMarker, ImageMarker, CircleMarker } from './components/Marker';
import Markers from './components/Markers';
import Navigate from './components/Navigate';
import Polyline from './components/Polyline';
import Circle from './components/Circle';
import Autocomplete from './components/Autocomplete';
import Geocoder from './components/Geocoder';
import MapPlayer from './components/MapPlayer';
import Polygon from './components/Polygon';
import PolylineSelector from './components/PolylineSelector';
import MarkerSelector from './components/MarkerSelector';
import PathSimplifier from './components/PathSimplifier';
import TrackHistory from './components/TrackHistory';

import useMap from './hooks/useMap';
import useInterval from './hooks/useInterval';

import { MapLBSType } from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const hereMap = require('sofa-heremap');

// 获取地图供应商
const getMapLBS = () => localStorage.getItem('SofaMapLBS');

const setHMapKey = hereMap.setHMapKey;
const setHMapVersion = hereMap.setHMapVersion;

const defaultMap = getMapLBS() === 'here';

let XMap = defaultMap ? hereMap.Map : Map;
let XMarker = defaultMap ? hereMap.Marker : Marker;
let XIconMarker = defaultMap ? hereMap.IconMarker : IconMarker;
let XImageMarker = defaultMap ? hereMap.ImageMarker : ImageMarker;
let XMarkers = defaultMap ? hereMap.Markers : Markers;
let XNavigate = defaultMap ? hereMap.Navigate : Navigate;
let XPolyline = defaultMap ? hereMap.Polyline : Polyline;
let XCircle = defaultMap ? hereMap.Circle : Circle;
let XAutocomplete = defaultMap ? hereMap.Autocomplete : Autocomplete;
let XGeocoder = defaultMap ? hereMap.Geocoder : Geocoder;
let XMapPlayer = defaultMap ? hereMap.MapPlayer : MapPlayer;
let XPolygon = defaultMap ? hereMap.Polygon : Polygon;
let XPolylineSelector = defaultMap ? hereMap.PolylineSelector : PolylineSelector;
let XMarkerSelector = defaultMap ? hereMap.MarkerSelector : MarkerSelector;

/**
 * setMapLBS
 * 设置地图供应商
 * @param lbs 地图供应商 'gaode' | 'here'
 */
const setMapLBS = (lbs: MapLBSType) => {
  localStorage.setItem('SofaMapLBS', lbs);

  const isHere = lbs === 'here';

  XMap = isHere ? hereMap.Map : Map;
  XMarker = isHere ? hereMap.Marker : Marker;
  XIconMarker = isHere ? hereMap.IconMarker : IconMarker;
  XImageMarker = isHere ? hereMap.ImageMarker : ImageMarker;
  XMarkers = isHere ? hereMap.Markers : Markers;
  XNavigate = isHere ? hereMap.Navigate : Navigate;
  XPolyline = isHere ? hereMap.Polyline : Polyline;
  XCircle = isHere ? hereMap.Circle : Circle;
  XAutocomplete = isHere ? hereMap.Autocomplete : Autocomplete;
  XGeocoder = isHere ? hereMap.Geocoder : Geocoder;
  XMapPlayer = isHere ? hereMap.MapPlayer : MapPlayer;
  XPolygon = isHere ? hereMap.Polygon : Polygon;
  XPolylineSelector = isHere ? hereMap.PolylineSelector : PolylineSelector;
  XMarkerSelector = isHere ? hereMap.MarkerSelector : MarkerSelector;

  console.log('sofa-map 当前地图供应商: ', lbs);
};

export {
  useMap,
  useInterval,
  setHMapKey,
  setHMapVersion,
  setAMapVersion,
  setAMapKey,
  setMapLBS,
  getMapLBS,
  XMap as Map,
  XMarker as Marker,
  XIconMarker as IconMarker,
  XImageMarker as ImageMarker,
  XMarkers as Markers,
  XNavigate as Navigate,
  XPolyline as Polyline,
  XCircle as Circle,
  XAutocomplete as Autocomplete,
  XGeocoder as Geocoder,
  XMapPlayer as MapPlayer,
  XPolygon as Polygon,
  XPolylineSelector as PolylineSelector,
  XMarkerSelector as MarkerSelector,
  PathSimplifier,
  CircleMarker,
  TrackHistory,
};
